// extracted by mini-css-extract-plugin
module.exports = {"spin":"ui-icons_spin__i_dn3","rotation":"ui-icons_rotation__XbYoq"};